export interface JournalTopicMeta {
  title: string;
  description: string;
}

export const JOURNAL_TOPICS_META: Record<string, JournalTopicMeta> = {
  'avto-i-moto': {
    title: 'Полезные статьи об авто и мото - Юрик.ру',
    description:
      'Читайте полезные статьи об авто и мото, чтобы быть в курсе всех юридических аспектов, связанных с транспортом.',
  },
  'voennoe-pravo': {
    title: 'Полезные статьи о военном праве - Юрик.ру',
    description:
      'Узнайте все о военном праве из наших полезных статей, написанных профессиональными юристами.',
  },
  'dolgi-i-bankrotstvo': {
    title: 'Полезные статьи о долгах и банкротстве - Юрик.ру',
    description:
      'Полезные статьи о долгах и банкротстве помогут вам разобраться в сложных юридических вопросах.',
  },
  'semya-i-deti': {
    title: 'Полезные статьи о семье и детях - Юрик.ру',
    description:
      'Читайте полезные статьи о семье и детях, чтобы быть в курсе всех юридических нюансов семейного права.',
  },
  'kvartira-i-dom': {
    title: 'Полезные статьи о квартире и доме - Юрик.ру',
    description:
      'Полезные статьи о квартире и доме помогут вам разобраться в юридических вопросах недвижимости.',
  },
  'nasledstvo-i-zaveshanie': {
    title: 'Полезные статьи о наследстве и завещании - Юрик.ру',
    description:
      'Узнайте все о наследстве и завещании из наших полезных статей, написанных профессиональными юристами.',
  },
  'pensiya-i-lgoty': {
    title: 'Полезные статьи о пенсиях и льготах - Юрик.ру',
    description:
      'Полезные статьи о пенсиях и льготах помогут вам разобраться в сложных юридических вопросах.',
  },
  'sudy-i-pristavy': {
    title: 'Полезные статьи о судах и судебных приставах - Юрик.ру',
    description:
      'Читайте полезные статьи о судах и судебных приставах, чтобы быть в курсе всех юридических нюансов.',
  },
  'biznes-i-finansy': {
    title: 'Полезные статьи о бизнесе и финансах - Юрик.ру',
    description:
      'Полезные статьи о бизнесе и финансах помогут вам разобраться в юридических вопросах предпринимательства.',
  },
  'grazhdanskoe-i-administrativnoe-pravo': {
    title: 'Полезные статьи о гражданском и административном праве - Юрик.ру',
    description:
      'Узнайте все о гражданском и административном праве из наших полезных статей, написанных профессиональными юристами.',
  },
  'zemlya-i-dacha': {
    title: 'Полезные статьи о земле и даче - Юрик.ру',
    description:
      'Полезные статьи о земле и даче помогут вам разобраться в юридических вопросах земельного права.',
  },
  'kredity-i-strahovki': {
    title: 'Полезные статьи о кредитах и страховках - Юрик.ру',
    description:
      'Читайте полезные статьи о кредитах и страховках, чтобы быть в курсе всех юридических нюансов.',
  },
  'medicinskoe-pravo': {
    title: 'Полезные статьи о медицинском праве - Юрик.ру',
    description:
      'Полезные статьи о медицинском праве помогут вам разобраться в сложных юридических вопросах.',
  },
  'prava-potrebitelej': {
    title: 'Полезные статьи о защите прав потребителей - Юрик.ру',
    description:
      'Узнайте все о защите прав потребителей из наших полезных статей, написанных профессиональными юристами.',
  },
  'rabota-i-zarplata': {
    title: 'Полезные статьи о работе и зарплате - Юрик.ру',
    description:
      'Полезные статьи о работе и зарплате помогут вам разобраться в юридических вопросах трудового права.',
  },
  'ugolovnoe-pravo': {
    title: 'Полезные статьи об уголовном праве - Юрик.ру',
    description:
      'Изучите полезные статьи об уголовном праве, чтобы понять юридические аспекты уголовных процессов, ответственности и защиты прав.',
  },
};

export const buildJournalTopicMeta = (
  slug: string,
  topicName: string,
  topicDescription: string,
): JournalTopicMeta =>
  JOURNAL_TOPICS_META[slug] ?? {
    title: topicName ? `Полезные статьи — ${topicName} - Юрик.ру` : '',
    description: topicDescription,
  };
